import type { PropsWithChildren } from 'react';

import { cn } from '@/utils/cn';

type SkeletonProps = {
  className?: string;
};

export function Skeleton({ className }: SkeletonProps) {
  return <div aria-hidden="true" className={cn('animate-pulse rounded-2xl bg-slate-200/90 dark:bg-slate-800/80', className)} />;
}

export function SkeletonCircle({ className }: SkeletonProps) {
  return <Skeleton className={cn('rounded-full', className)} />;
}

export function SkeletonStack({ className, children }: PropsWithChildren<SkeletonProps>) {
  return <div className={cn('space-y-3', className)}>{children}</div>;
}

export function SkeletonCard({ className, children }: PropsWithChildren<SkeletonProps>) {
  return <div className={cn('rounded-[1.35rem] border border-slate-200/80 bg-white p-4 shadow-sm dark:border-slate-700/90 dark:bg-slate-900/95', className)}>{children}</div>;
}
